import * as React from 'react';
import { LuWandSparkles } from 'react-icons/lu';

/**
 * The AI assistant entry point: a purple wand icon button that pops once shortly
 * after mount to draw attention (see .ai-wand-button in custom.css).
 * Set overlay when rendered on top of an input so it gets a legible backdrop.
 */
export const AiWandButton = ({ onClick, title, size = 16, tagName, overlay, style }) => (
  <button
    type="button"
    className={overlay ? 'ai-wand-button ai-wand-overlay' : 'ai-wand-button'}
    data-tagname={tagName}
    title={title}
    aria-label={title}
    onClick={onClick}
    style={style}
  >
    <LuWandSparkles size={size} />
  </button>
);
